module.exports = __webpack_public_path__ + "img/user-suspend-icon-grey.d9fabb0a.svg";